// extracted by mini-css-extract-plugin
export default {"ctn":"custom_ctn__sVjY3","contentItem":"custom_contentItem__F7J5M","textBox":"custom_textBox__87h1R"};